import React from 'react';
import styled from 'styled-components/macro';

import { colors } from '../../styles/constants';

export const AppBarContainer = ({ children }: { children: React.ReactNode}) => (
    <AppBarBg>
        <AppBarContainerInner>{children}</AppBarContainerInner>
    </AppBarBg>
);

export const AppBarBg = styled.div`
    background: ${colors.primary};
    position: sticky;
    top: 0;
    bottom: 0;

    &:before {
        position: absolute;
        content: '';
        top: -100px;
        height: 100px;
        width: 100%;
        background: ${colors.primary};
    }

    @media (max-width: 768px) {
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        height: 64px;
        width: 100%;
        top: auto;
        bottom: auto;
    }

    width: 200px;
`;

export const AppBarContainerInner = styled.nav`
    min-height: 100vh;
    height: 100%;
    align-self: flex-start;
    width: 50px;
    display: flex;
    flex-direction: column;
    z-index: 1;
    overflow: initial;
    transition: all 200ms ease-out;

    @media (max-width: 768px) {
        min-height: auto;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        height: 64px;
        width: 100%;
        z-index: 100;
        align-items: center;
    }

    width: 200px;
`;

export const AtTheTop = styled.div`
    flex-grow: 99;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const AtTheBottom = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const Spacer = styled.div`
    padding-bottom: 16px;
`;
